export default {
    title_list: 'Brain health',

    filter: {
    },

    table: {
        labels: {
            id: 'ID',
            path_func: 'Func file',
            path_lld: 'LLD file',
            brain_health_id: 'Brain Health ID',
            user: 'User',
            processing_date: 'Processing date',
        }
    },

    buttons: {
    },

    form: {
    },
}
